import { Reveal } from "@/components/Reveal";
import { LeFil } from "@/components/LeFil";
import { PhoneFrame, DashboardScreen, MedicationScreen, SosScreen, CallScreen } from "@/components/PhoneMockup";

const SCREENS = [
  { label: "Health Dashboard", Screen: DashboardScreen },
  { label: "Medications", Screen: MedicationScreen },
  { label: "Emergency SOS", Screen: SosScreen },
  { label: "Voice & Video", Screen: CallScreen },
];

export default function Screenshots() {
  return (
    <section id="screenshots" className="scroll-mt-24 overflow-hidden bg-secondary/40 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-end">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold uppercase tracking-[0.15em] text-marigold-deep">A closer look</p>
            <h2 className="mt-3 font-heading text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
              Designed to feel effortless
            </h2>
            <p className="mt-4 text-lg text-muted-foreground">
              Every screen is crafted for clarity — so anyone in the family, of any age,
              can use it with confidence.
            </p>
          </div>
          <div className="w-full max-w-xs text-foreground/70 lg:w-64">
            <LeFil from="Mom" to="You" showLabels className="h-auto w-full" />
          </div>
        </Reveal>
      </div>

      <div className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-6 overflow-x-auto px-5 pb-6 sm:px-8 lg:justify-center">
        {SCREENS.map(({ label, Screen }, i) => (
          <Reveal key={label} delay={i * 0.08} className="snap-center shrink-0">
            <div className="text-center">
              <PhoneFrame>
                <Screen />
              </PhoneFrame>
              <p className="mt-4 text-sm font-medium text-muted-foreground">{label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
